import Vue from "vue";
import CXMApiClient from "../CXMApiClient";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {
    currentVehicles: [],
    showAddCompanyModal: false,
    selectedGarageVehicleInfo : null,
    DefaultSelectedVehicle: null,
  };
}

const state = initialState();

const getters = {
  currentVehicles: function(state) {
    return state.currentVehicles;
  },
  showAddCompanyModal: function(state) {
    return state.showAddCompanyModal;
  },
  selectedGarageVehicleInfo : function() {
    return state.selectedGarageVehicleInfo;
  },
  GetDefaultSelectedVehicle: () => state.DefaultSelectedVehicle
};

const actions = {
  clearCurrentVehicles: function(context) {
    this.commit("clearCurrentVehicles");
  },
  getCurrentVehicles: function(context) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "get",
            "/crm/contacts/" +
              context.getters.CurrentContact.id +
              "/service/vehicle", null, scope
          )
          .then(function(response) {
            if (response.data && response.data.data)
              context.commit("setCurrentVehicles", response.data.data);
          })
          .catch(function(error) {
            reject(error);
          })
      );
    });
  },
  getCompanyInfo: function(context) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "get",
            "/crm/contacts/" + context.getters.CurrentContact.id + "/companies",
            null,
            scope
          )
          .then(function(response) {
            if (response.data && response.data.successful)
              resolve(response.data.data);
            else resolve([{}]);
          })
          .catch(function(error) {
            resolve([{}]);
          })
      );
    });
  },
  saveCompanyInfo: function(context, info) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "put",
            "/crm/contacts/" + context.getters.CurrentContact.id + "/company",
            info, scope
          )
          .then(function(response) {
            if (response.data && response.data.successful) resolve(true);
            else resolve(false);
          })
          .catch(function(error) {
            console.log(error);
            reject(error);
          })
      );
    });
  },
  setGarageVehicleInfo : function(context, vehicleInfo) {
    context.commit('updateGarageVehicleInfo', vehicleInfo);
  },
  setDefaultSelectedVehicle: function (context, vehicleInfo) {
    context.commit("updateDefaultSelectedVehicle", vehicleInfo);
  },
  clearDefaultSelectedVehicle: function(context) {
    context.commit("clearDefaultSelectedVehicle");
  }
};

const mutations = {
  setCurrentVehicles: function(state, vehicles) {
    state.currentVehicles = vehicles;
  },
  clearCurrentVehicles: function(state) {
    state.currentVehicles = [];
  },
  updateDefaultSelectedVehicle: function(state, vehicle) {
    state.DefaultSelectedVehicle = vehicle;
  },
  clearDefaultSelectedVehicle: function(state) {
    state.DefaultSelectedVehicle = null;
  },
  toggleAddCompanyModal: function(state) {
    state.showAddCompanyModal = !state.showAddCompanyModal;
  },
  updateGarageVehicleInfo : function(state, vehicleInfo) {
    state.selectedGarageVehicleInfo = vehicleInfo;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/CustomerProfile.js